"use client";

import { useMutation } from "@tanstack/react-query";
import type { ConfirmPasswordResetRequest } from "cmw-client";
import { browserCmw } from "@/lib/ky/browser";

export type ResetPasswordInput = ConfirmPasswordResetRequest;

export const useResetPassword = () =>
  useMutation({
    mutationFn: (body: ResetPasswordInput) =>
      browserCmw.auth.confirmPasswordReset(body),
  });
